import { alpha } from '@material-ui/core/styles';
import {
  useCreateReferral,
  useGetReferralDetails,
} from 'app/core/api/referral/api-referral';
import { ReferralData } from 'app/core/api/referral/api-referral.types';
import Button from 'app/shared/components/button/Button';
import { CopyIconSvg } from 'app/shared/components/icon/icon-lib';
import Body from 'app/shared/components/typography/body/Body';
import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
import styledConsts from 'app/styles/styledConsts';
import styledFuncs from 'app/styles/styledFuncs';
import styledMixins from 'app/styles/styledMixins';
import { ReactComponent as TellAFriendSvg } from 'assets/tell-a-friend.svg';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { useIdentity } from 'app/core/api/company/api-company';
import { useHistory } from 'react-router-dom';
import bike from '../../../assets/bike.png';
import { ReactComponent as Number1 } from '../../../assets/icons/Number1.svg';
import { ReactComponent as Number2 } from '../../../assets/icons/Number2.svg';
import ConsumerRoutePath from '../ConsumerRoutePath';

const StyledSvg = styled(TellAFriendSvg)`
  width: auto;
`;
const Hr = styled.hr`
  border: ${styledConsts.cPrimary} 1px solid;
`;
const TextBody = styled(Body)`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: black;
`;
const StyledLink = styled.a`
  font-weight: 500;
  font-size: 16px;
  color: ${p => p.theme.palette.primary.main};
  margin-top: ${styledFuncs.pad(2.5)};
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${styledFuncs.pad(5)};
  > * {
    align-self: center;
  }
`;
const ShareButton = styled(Button)`
  &,
  &:hover,
  &.Mui-disabled {
    background-color: ${styledConsts.cError};
    color: #fff;
  }
  flex: 1 1 auto;
  ${styledMixins.noRadiusRight}
  div > div {
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
  }

  span {
    display: block;
    font-weight: 500;
    font-size: 10px;
    line-height: 15px;
  }
  .MuiButton-endIcon {
    display: none;
  }
`;
const CopyButton = styled(Button)`
  &,
  &:hover,
  &.Mui-disabled {
    background-color: ${styledConsts.cError};
  }
  &.Mui-disabled {
    background-color: ${p => alpha(styledConsts.cError(p), 0.6)};
  }
  margin-left: 1px;
  flex: 0 1 auto;
  padding: unset;
  ${styledMixins.noRadiusLeft}
`;
const PageTitle = styled(Body)`
  font-size: 30px;
  font-weight: 500;
  margin: 0 ${styledFuncs.pad(2)};
`;
const DetailsTitle = styled('h4')`
  font-weight: 500;
  font-size: 15px;
  color: red;
  padding: 0;
  margin: 0;
`;
const BoundingBox = styled.div`
  ${styledMixins.roundCorners}
  background: white;
  box-shadow: 0 0 3px #ddd;
  overflow: hidden;
  min-height: 57px;
  padding: 10px;
`;
const Number = styled.div`
  width: 20%;
  float: left;
  padding: ${styledFuncs.pad(1)};
`;
const Step = styled.div`
  width: 90%;
  font-size: 14px;
  padding-top: ${styledFuncs.pad(1.5)};
`;
const StepBox = styled.div`
  height: 57px;
`;
const GreenTitle = styled.p`
  font-weight: 600;
  font-size: 15px;
  color: #31ad31;
`;
const Content = styled.div`
  font-size: 14px;
  margin: 10px;
  float: left;
  width: 50%;
`;
const Claimed = styled.div`
  font-size: 13px;
  color: #eeb20d;
  font-weight: 600;
  margin: 10px;
  float: right;
  width: 30%;
`;
const Pending = styled.div`
  font-size: 13px;
  margin: 10px;
  float: right;
  width: 20%;
`;
const GreenTitle2 = styled.div`
  font-weight: 600;
  font-size: 15px;
  color: #31ad31;
  margin: 10px;
  float: left;
  width: 60%;
`;
export default function Refer(): JSX.Element {
  const { showSnack } = useShowInfo();
  const history = useHistory();
  const { resource: identity } = useIdentity();
  const { resource: referralData } = useGetReferralDetails();
  const { resource: referralLink, loading } = useCreateReferral(
    { redirectTo: window.location.origin },
    { fresh: true }
  );

  const [compRefCount, setCompRefCount] = useState<number>(0);
  // const [compRefFriendCount, setCompRefFriendCount] =
  //   useState<number>(0);
  // const { resource: referralCounter } = useGetReferralCount();
  // const [referralCount, setReferralCount] = useState<User[]>();

  useEffect(() => {
    if (identity) {
      setCompRefCount(identity.refCount);
    }
  }, [identity]);

  // useEffect(() => {
  //   if (referralData) {
  //     setCompRefFriendCount(referralData.productAddedCount);
  //   }
  // }, [referralData]);

  // const refer = false;
  const shareAvailable = !!navigator.share;

  const invokeShareFeature = () => {
    if (shareAvailable) {
      navigator
        .share({
          title: `Share iWarranty`,
          text: `Check out iWarranty, the smarter way to track your product warranties and manage repairs`,
          url: referralLink?.url,
        })
        .catch((error: unknown) => {
          if (_.isError(error) && error.name === 'AbortError') return;
          showSnack({
            message: 'Something went wrong! Please try again.',
          });
        });
    }
  };
  const copyToClipboard = async () =>
    navigator.clipboard
      .writeText(referralLink?.url || '')
      .then(() => {
        showSnack({
          message: 'Link copied to clipboard!',
        });
      });
  return (
    <>
      {!identity?.isPartOfCompetition ? (
        <>
          <StyledSvg />
          <Hr />
          <TextBody>
            Refer a friend to iWarranty and you’ll get a special
            reward. They just need to sign up using your referral
            link.
          </TextBody>
          <StyledLink>Share your link</StyledLink>
          <ButtonContainer>
            <ShareButton
              onClick={invokeShareFeature}
              disabled={loading || !shareAvailable}
            >
              <div>
                {/* <div>{referralLink?.code || 'Loading...'}</div> */}
                <div>Referal Link</div>
                {shareAvailable && referralLink?.url && (
                  <span>tap to share</span>
                )}
              </div>
            </ShareButton>
            <CopyButton onClick={copyToClipboard} disabled={loading}>
              <CopyIconSvg />
            </CopyButton>
          </ButtonContainer>
        </>
      ) : (
        <>
          <PageTitle>
            Celebrating
            <span style={{ color: '#31ad31' }}>
              <br /> Motorcycle Live
            </span>
          </PageTitle>
          <DetailsTitle>
            Running from 12 Nov to 11 Dec 2022
          </DetailsTitle>
          <img
            src={bike}
            alt="Bike"
            style={{
              height: '200px',
              width: '200px',
              margin: '0 auto',
            }}
          />
          <text
            style={{
              fontWeight: 500,
              fontSize: '16px',
            }}
          >
            Refer a friend to iWarranty and you'll get an additional
            chance to win a <b>Super Soco TC!</b>
          </text>
          <GreenTitle>What do my friends need to do?</GreenTitle>
          <BoundingBox>
            <StepBox>
              <Number>
                <Number1 />
              </Number>
              <Step>Register an account using your link</Step>
            </StepBox>
            <StepBox>
              <Number>
                <Number2 />
              </Number>
              <Step>Upload 3 products</Step>
            </StepBox>
          </BoundingBox>
          {compRefCount > 0 && compRefCount !== referralData?.length && (
            <>
              <div style={{ margin: '0' }}>
                <GreenTitle2>Referrals Sent</GreenTitle2>
              </div>
              <BoundingBox>
                <Content>{compRefCount} pending</Content>
              </BoundingBox>
            </>
          )}
          {compRefCount > 0 &&
            referralData &&
            referralData.map((val: ReferralData) => (
              <>
                <div style={{ margin: '0' }} key={val.email}>
                  <GreenTitle2>Referrals Sent</GreenTitle2>
                  {compRefCount === referralData.length ? (
                    ''
                  ) : (
                    <Pending>{compRefCount} pending</Pending>
                  )}
                </div>
                <BoundingBox>
                  <Content>{val.email}</Content>
                  <Claimed>
                    {val.productAddedCount}/3 products added
                  </Claimed>
                </BoundingBox>
              </>
            ))}
          <ButtonContainer>
            <ShareButton
              onClick={invokeShareFeature}
              disabled={loading || !shareAvailable}
            >
              <div>
                {/* <div>{referralLink?.code || 'Loading...'}</div> */}
                <div>Tap to share</div>
                {shareAvailable && referralLink?.url && (
                  <span>tap to share</span>
                )}
              </div>
            </ShareButton>
            <CopyButton onClick={copyToClipboard} disabled={loading}>
              <CopyIconSvg />
            </CopyButton>
          </ButtonContainer>
          <text
            style={{
              margin: '0 auto 10px auto',
              fontSize: '11px',
              color: 'red',
            }}
            onClick={() =>
              history.push(`${ConsumerRoutePath.COMPETITION_TERMS}`)
            }
          >
            *Terms & Conditions apply
          </text>
        </>
      )}
    </>
  );
}
